function htmlMarkup(html) {
  return { __html: html || '' }
}

function FooterMenuColumn({ column }) {
  return (
    <nav className="nova-footer-menu-widget__column" aria-label={column.name || column.title}>
      {column.title ? <h3 className="nova-footer-menu-widget__column-title">{column.title}</h3> : null}
      <div className="nova-footer-menu-widget__menu-wrap" dangerouslySetInnerHTML={htmlMarkup(column.markup)} />
    </nav>
  )
}

export function FooterMenuWidget({ payload }) {
  const labels = payload.labels || {}
  const columns = Array.isArray(payload.columns) ? payload.columns : []

  if (!columns.length) {
    if (!payload.showEmptyNotice) return null

    return (
      <p className="nova-footer-menu-widget__notice">
        {labels.empty || 'Selectionnez jusqu a 4 menus avec des liens dans Liste widget > Footer menu.'}
      </p>
    )
  }

  return (
    <div className="nova-footer-menu-widget">
      {payload.title ? <h2 className="nova-footer-menu-widget__title">{payload.title}</h2> : null}

      <div className="nova-footer-menu-widget__grid">
        {columns.map((column, index) => (
          <FooterMenuColumn key={`${column.id || column.title || 'menu'}-${index}`} column={column} />
        ))}
      </div>
    </div>
  )
}
